import { NewElectricityAgreementState } from 'models/electricity/new-electricity-agreement';
import React, { useContext, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { AuthenticationContext } from 'services/context/authentication.context';

const getTitle = (item: NewElectricityAgreementState): string => {
    switch (item) {
        case NewElectricityAgreementState.ACCEPT_TERMS:
            return 'Nõusolek';
        case NewElectricityAgreementState.DATA_AND_METERING_POINTS:
            return 'Andmed';
        case NewElectricityAgreementState.CHOOSE_PACKAGE:
            return 'Paketi valik';
        case NewElectricityAgreementState.CONFIRM:
            return 'Sõlmi leping';
        default:
            return 'Leping sõlmitud!';
    }
}

const HeaderMenuOption = (
    { index, title, onClick, isActive, isCompleted }: { index: number, title: string, onClick: ()  => void, isActive: boolean, isCompleted: boolean}
) => {

    let className = 'new-electricity-agreement__header__option step-' + index;
    if (isActive) {
        className += ' new-electricity-agreement__header__option--active';
    }
    if (isCompleted) {
        className += ' new-electricity-agreement__header__option--completed';
    }

    return (
        <div 
            role='button' 
            className={className}
            onClick={onClick}
        >
            { title }
        </div>
    )
}

const HeaderMobileModal = (
    { visible, onHide, activeItem, currentItem, onClick, indexOffset, acceptingOffer }:
    { visible: boolean, onHide: any, activeItem: NewElectricityAgreementState, currentItem: NewElectricityAgreementState, onClick: any, indexOffset: number, acceptingOffer: boolean }
) => {

    return (
        <Modal
            show={visible}
            onHide={onHide}
            backdropClassName="new-electricity-agreement__header__menu-modal__backdrop"
            dialogClassName="new-electricity-agreement__header__menu-modal__container"
        >
            <Modal.Header closeButton />
            <Modal.Body>
                <HeaderMenuOptionList 
                    activeItem={activeItem}
                    currentItem={currentItem}
                    onClick={onClick}
                    indexOffset={indexOffset}
                    acceptingOffer={acceptingOffer}
                />
            </Modal.Body>
        </Modal>
    )
}

const HeaderMenuOptionList = (
    { activeItem, currentItem, onClick, indexOffset, acceptingOffer }:
    { activeItem: NewElectricityAgreementState, currentItem: NewElectricityAgreementState, onClick: any, indexOffset: number, acceptingOffer: boolean }) => {
    const { state } = useContext(AuthenticationContext);

    return (
        <>
            { !!state.changePackageAgreement || acceptingOffer ? null : <><HeaderMenuOption
                index={NewElectricityAgreementState.ACCEPT_TERMS + indexOffset}
                title={getTitle(NewElectricityAgreementState.ACCEPT_TERMS)}
                onClick={() => onClick(NewElectricityAgreementState.ACCEPT_TERMS)}
                isActive={activeItem === NewElectricityAgreementState.ACCEPT_TERMS}
                isCompleted={currentItem > NewElectricityAgreementState.ACCEPT_TERMS}
            ></HeaderMenuOption>
            <HeaderMenuOption
                index={NewElectricityAgreementState.DATA_AND_METERING_POINTS + indexOffset}
                title={getTitle(NewElectricityAgreementState.DATA_AND_METERING_POINTS)}
                onClick={() => onClick(NewElectricityAgreementState.DATA_AND_METERING_POINTS)}
                isActive={activeItem === NewElectricityAgreementState.DATA_AND_METERING_POINTS}
                isCompleted={currentItem > NewElectricityAgreementState.DATA_AND_METERING_POINTS}
            ></HeaderMenuOption></> }
            { acceptingOffer ? null : <HeaderMenuOption
                index={NewElectricityAgreementState.CHOOSE_PACKAGE + indexOffset}
                title={getTitle(NewElectricityAgreementState.CHOOSE_PACKAGE)}
                onClick={() => onClick(NewElectricityAgreementState.CHOOSE_PACKAGE)}
                isActive={activeItem === NewElectricityAgreementState.CHOOSE_PACKAGE}
                isCompleted={currentItem > NewElectricityAgreementState.CHOOSE_PACKAGE}
            ></HeaderMenuOption> }
            <HeaderMenuOption
                index={NewElectricityAgreementState.CONFIRM + indexOffset}
                title={getTitle(NewElectricityAgreementState.CONFIRM)}
                onClick={() => onClick(NewElectricityAgreementState.CONFIRM)}
                isActive={activeItem === NewElectricityAgreementState.CONFIRM}
                isCompleted={currentItem === NewElectricityAgreementState.COMPLETED}
            ></HeaderMenuOption>
        </>
    );
}

interface NewElectricityAgreementHeaderProps {
    activeItem: NewElectricityAgreementState;
    setActiveItem: (option: NewElectricityAgreementState) => void;
    currentItem: NewElectricityAgreementState;
    disabled: boolean;
    changingPackage: boolean;
    acceptingOffer: boolean;
}

export default function NewElectricityAgreementHeader(
    { activeItem, setActiveItem, currentItem, disabled, changingPackage, acceptingOffer }: NewElectricityAgreementHeaderProps
) {

    const [mobileMenuVisible, setMobileMenuVisible] = useState(false);

    const onClick = (newState: NewElectricityAgreementState) => {
        if (disabled || newState > currentItem) {
            return;
        }
        setActiveItem(newState);
    }

    const stepCount = changingPackage ? 2 : acceptingOffer ? 1 : 4;
    const indexOffset = changingPackage ? -1 : acceptingOffer ? -2 : 1;
    const step = activeItem + indexOffset;

    return (
        <>
            <div className='new-electricity-agreement__header'>
                <HeaderMenuOptionList 
                    activeItem={activeItem}
                    currentItem={currentItem}
                    onClick={onClick}
                    indexOffset={indexOffset}
                    acceptingOffer={acceptingOffer}
                />
            </div>
            <div className='new-electricity-agreement__header--mobile'>
                <div className='d-flex justify-content-between align-items-center h-100 px-3'>
                    <HeaderMenuOption
                        index={step}
                        title={getTitle(activeItem)}
                        onClick={() => setMobileMenuVisible(true)}
                        isActive={true}
                        isCompleted={currentItem > activeItem}
                    ></HeaderMenuOption>
                    <div className='u-fs-16'><strong>{ step }</strong> / {stepCount}</div>
                </div>
                <div className='new-electricity-agreement__header--mobile__progress' style={{ width: (step/stepCount * 100) + '%'}}></div>
            </div>
            <HeaderMobileModal
                visible={mobileMenuVisible}
                onHide={() => setMobileMenuVisible(false)}
                activeItem={activeItem}
                currentItem={currentItem}
                onClick={onClick}
                indexOffset={indexOffset}
                acceptingOffer={acceptingOffer}
            />
        </>
    );
}
